function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.index-of";
import _unionBy from "lodash/unionBy";
import _values from "lodash/values";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getId, isActive, getProductType } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/nw-api-sdk/marketplace';
import getDisplayName from '../../lib/get-display-name';
var MarketplaceContext = /*#__PURE__*/React.createContext({});
export default MarketplaceContext;
var COMPLIANCE_OK_FIELDS = ['name', 'product.name', 'institution.name', 'product.institution.name', 'details.seo_name', 'derived_details.reward_cents_per_unit_string'];

var getEntitiesFromProps = function getEntitiesFromProps(props) {
  var _props$data$value, _props$data;

  return _values((_props$data$value = props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.value) !== null && _props$data$value !== void 0 ? _props$data$value : {});
};

export var isCreditCardProduct = function isCreditCardProduct(entity) {
  return getProductType(entity) === PRODUCT_TYPES.CREDIT_CARDS;
};
export var getInactiveEntitiesFromProps = function getInactiveEntitiesFromProps(props) {
  var entities = getEntitiesFromProps(props);
  var inactiveEntities = [];
  if (!entities.length) return []; // Ignore MarketplaceField components when the field is not a compliance-flagged field.
  // We don't need to show the out-of date messaging if this field isn't a compliance concern.

  if (COMPLIANCE_OK_FIELDS.indexOf(props.field) > -1) return [];
  entities.forEach(function (entity) {
    if (!entity || !isCreditCardProduct(entity) || isActive(entity)) {
      return;
    }

    inactiveEntities.push(entity);
  });
  return inactiveEntities;
}; // Provider consumes values from parent
// and falls back to providing its own if undefined

var MarketplaceContextProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(MarketplaceContextProvider, _React$Component);

  var _super = _createSuper(MarketplaceContextProvider);

  function MarketplaceContextProvider() {
    var _this;

    _classCallCheck(this, MarketplaceContextProvider);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "registerMarketplaceEntities", function (props) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$registerInactive = _ref.registerInactive,
          registerInactive = _ref$registerInactive === void 0 ? true : _ref$registerInactive;

      var entities = getEntitiesFromProps(props);
      var inactiveEntities = registerInactive ? getInactiveEntitiesFromProps(props) : [];

      _this.setState(function (oldState) {
        var newState = {};

        var newEntities = _unionBy(oldState.entities, entities, function (entity) {
          return getId(entity);
        });

        if (newEntities.length !== oldState.entities.length) newState.entities = newEntities;

        var newInactiveEntities = _unionBy(oldState.inactiveEntities, inactiveEntities, function (entity) {
          return getId(entity);
        });

        if (newInactiveEntities.length !== oldState.inactiveEntities.length) newState.inactiveEntities = newInactiveEntities;
        return newState;
      });
    });

    _this.state = {
      entities: [],
      inactiveEntities: []
    };
    return _this;
  }

  _createClass(MarketplaceContextProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var _this$state = this.state,
          entities = _this$state.entities,
          inactiveEntities = _this$state.inactiveEntities;
      return /*#__PURE__*/React.createElement(MarketplaceContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(MarketplaceContext.Provider, {
          value: {
            registerMarketplaceEntities: ctx.registerMarketplaceEntities || _this2.registerMarketplaceEntities,
            entities: ctx.entities || entities,
            inactiveEntities: ctx.inactiveEntities || inactiveEntities
          }
        }, children);
      });
    }
  }]);

  return MarketplaceContextProvider;
}(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


MarketplaceContextProvider.defaultProps = {}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

MarketplaceContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export { MarketplaceContextProvider };
/**
 * HOC that takes a Component and options object and registers marketplace entities
 * into a MarketplaceContext after entities are resolved in props.data
 *
 * @export
 * @param {*} Component
 * @param {*} { registerInactive = true} Options
 * @returns wrapped component
 */

export function withMarketplaceContext(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithMarketplaceContextImpl = function WithMarketplaceContextImpl(_ref2) {
    var _props$data4;

    var registerMarketplaceEntities = _ref2.registerMarketplaceEntities,
        props = _objectWithoutProperties(_ref2, ["registerMarketplaceEntities"]);

    useEffect(function () {
      var _props$data2, _props$data3;

      if (props !== null && props !== void 0 && (_props$data2 = props.data) !== null && _props$data2 !== void 0 && _props$data2.loading) return;
      if (!(props !== null && props !== void 0 && (_props$data3 = props.data) !== null && _props$data3 !== void 0 && _props$data3.value)) return;
      registerMarketplaceEntities(props, options);
    }, // eslint-disable-next-line react/destructuring-assignment, react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
    [props === null || props === void 0 ? void 0 : (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.value]);
    return /*#__PURE__*/React.createElement(Component, props);
  };

  WithMarketplaceContextImpl.propTypes = _objectSpread({
    registerMarketplaceEntities: PropTypes.func
  }, Component.propTypes);
  WithMarketplaceContextImpl.defaultProps = Component.defaultProps;

  var WithMarketplaceContext = function WithMarketplaceContext(props) {
    return /*#__PURE__*/React.createElement(MarketplaceContext.Consumer, null, function (_ref3) {
      var registerMarketplaceEntities = _ref3.registerMarketplaceEntities;
      return /*#__PURE__*/React.createElement(WithMarketplaceContextImpl, _extends({}, props, {
        registerMarketplaceEntities: registerMarketplaceEntities
      }));
    });
  };

  hoistNonReactStatics(WithMarketplaceContext, Component);
  WithMarketplaceContext.propTypes = Component.propTypes;
  WithMarketplaceContext.defaultProps = Component.defaultProps;
  WithMarketplaceContext.displayName = "WithMarketplaceContext(".concat(getDisplayName(Component), ")"); // eslint-disable-line prettier/prettier

  return WithMarketplaceContext;
}